import React from 'react';

export default function NotFoundView() {
    return (
        <div>404: Not Found</div>
    );
}